import leituras from "./leituras"
import relacaoDocsPagos from "./relacao-docs-pagos"
import segundaVia from "./segunda-via"


export default {
    path: "/financeiro",
    component: () => import("~/pages/financeiro/index.vue"),
    children: [
        {
            path: "",
            meta: {
                isMainScreen: true,
            },
            component: () => import("~/pages/financeiro/financeiro.vue"),
        },
        {
            path: "conta-corrente",
            component: () => import("~/pages/financeiro/conta-corrente.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "inadimplentes",
            component: () => import("~/pages/financeiro/inadimplentes.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        leituras,
        
        segundaVia,
        relacaoDocsPagos,
        
        {
            path: "relacao-valores",
            component: () =>
                import("~/pages/financeiro/relacao-valores.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "autorizacao-notas",
            component: () =>
                import("~/pages/financeiro/autorizacao-notas.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "documentos",
            component: () => import("~/pages/financeiro/documentos.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "livro-digital",
            component: () => import("~/pages/financeiro/livro-digital.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "historico-juridico",
            component: () =>
                import("~/pages/financeiro/historico-juridico.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "vencimento-ago",
            component: () => import("~/pages/financeiro/vencimento-ago.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "demonstrativo-financeiro",
            component: () =>
                import("~/pages/financeiro/demonstrativo-financeiro.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "informe-rendimentos",
            component: () =>
                import("~/pages/financeiro/informe-rendimentos.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "consultar-recibos",
            component: () =>
                import("~/pages/financeiro/consultar-recibos.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "graficos",
            component: () => import("~/pages/financeiro/graficos/index.vue"),
            meta: {
                isMainScreen: true,
            },
        }
    ],
}
    